import {CLEAR_USER} from "../actions/userActions";

const initialState = {
    text: '',
    open: false
}

export default function error( state = initialState, action ) {
    switch ( action.type ) {
        case 'ERROR_ACTION':
            return {
                ...state, text: action.text, open: action.open
            };
        case CLEAR_USER:
            return {
                ...initialState
            }
        default: return state;
    }
}